import type {ShopChosenItem} from "./ShopChosenItem";

/**
 * Co użytkownik wybrał sobie ze sklepu
 */
export class ShopChosenModel {
    /**
     * Ilości wybranych artykułów per id artykułu
     */
    chosenItems: Record<number,ShopChosenItem> = {}
    /**
     * Suma wartości sklepu
     */
    sum: number = 0
}